import React, {useEffect} from 'react'
import { Trans, useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'
import {Form, Radio, Space} from 'antd'
import {TwoFAModalStoreInterface} from '@/stores/profile/TwoFAModalStore/TwoFAModalStoreInterface'
import {TwoFAModalStoreSymbol} from '@/pages/Profile/components/TwoFA/components/TwoFAModal'

import styles from './styles.scss'
import {FREQUENCY_TWO_FA_CODE} from '@/constants/playwright-ids'

const {useForm} = Form

type TwoFAFrequencyProps = {
    onChange?: (v: string) => void
}

export const TwoFAFrequency: React.FC<TwoFAFrequencyProps> = observer(({onChange}) => {
    const { t } = useTranslation()
    const {selectedFrequency, settings} =
        useInjection<TwoFAModalStoreInterface>(TwoFAModalStoreSymbol)

    const frequencies = settings?.frequencies

    const [form] = useForm()

    useEffect(() => {
        form.setFieldsValue({frequency: selectedFrequency})
    }, [selectedFrequency])

    return (
        <Form form={form}>
            <Form.Item name={'frequency'} className={styles.formItem}>
                <Radio.Group>
                    <Space direction={'vertical'}>
                        {frequencies &&
                            frequencies.map(({id, value}) => (
                                <Radio
                                    key={id}
                                    value={id}
                                    onChange={v => onChange(v.target.value)}
                                    data-test-id={FREQUENCY_TWO_FA_CODE}
                                >
                                    <Trans
                                        i18nKey={`TwoFAFrequency.name.${value}`}
                                        components={{ strong: <strong /> }}
                                    />
                                </Radio>
                            ))}
                    </Space>
                </Radio.Group>
            </Form.Item>
        </Form>
    )
})
